import React from "react";
import {connect} from "react-redux";
import {
    recreateSchematicsTabs,
    selectSymbol,
    setActivePreviewSymbol,
    setSchematicListElement,
    setSymbolTypes
} from "../../store/Schematic_store/actions";

import SymbolsSelector from './SymbolsSelector/SymbolsSelector';

class RightToolbar extends React.PureComponent {


    render() {
        return (
            <div className='body_right_div'>
                <SymbolsSelector {...this.props} />
            </div>
        )
    }
}

const mapStateToProps = ({schematicReducers}) => {
    return {
        activeSchematicType: schematicReducers.activeSchematicType,
        previewSymbol: schematicReducers.previewSymbol,
        selectedSymbol: schematicReducers.selectedSymbol,
        graph: schematicReducers.graph.value,
        schematicList: schematicReducers.schematicList,
        symbolsTypes: schematicReducers.symbolsTypes,
        sidebarVisible: schematicReducers.sidebarVisible,
        backgrounds: schematicReducers.backgrounds
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSchematicElement: (schematicUpdated) => {
            dispatch(setSchematicListElement(schematicUpdated))
        },
        recreateSchematicsTabs: (elements) => {
            dispatch(recreateSchematicsTabs(elements))
        },
        setActiveSymbol: (symbol) => {
            dispatch(setActivePreviewSymbol(symbol))
        },
        selectedSymbol: (symbol) => {
            dispatch(selectSymbol(symbol))
        },
        setSymbolTypes: (symbolTypes) => {
            dispatch(setSymbolTypes(symbolTypes))
        },

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RightToolbar);
